import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of automotive information.', 'This is not a traditional textbook filled with long theory that you still need to transform into a class.', 'This is not an app.', 'This is not a video course.'];
const flow = ['OPEN THE SYSTEM', 'CHOOSE THE TOPIC', 'SELECT THE LESSON', 'TEACH'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-primary tech-grid relative overflow-hidden" data-id="element-263" data-mp="z37jzska7gl4">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-accent/60" data-id="element-264" data-mp="u4e7o3gqdvmj" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-265" data-mp="17zyg24yu2vfp">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-266" data-mp="13zei4z6frnsi">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-white/10 text-accent mb-5" data-id="element-267" data-mp="2ff34ppfs2kss">
            <span className="text-2xl" data-id="element-268" data-mp="2bxtfx23o5i0y">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold uppercase mb-4 text-white" data-id="element-269" data-mp="2gtqy7dyhsygd">
            The Complete Automotive Technology Teaching System for Instructors Worldwide
          </h2>
          <h3 className="text-xl font-display font-bold tracking-wide text-accent mb-3" data-id="element-270" data-mp="2puf7jvcxyamx">
            AUTOMOTIVE TECHNOLOGY INSTRUCTOR READY
          </h3>
          <p className="text-base md:text-lg text-white font-semibold mb-1" data-id="element-271" data-mp="1x6sxc497k7r3">
            A Complete 6-in-1 Visual Teaching System
          </p>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-272" data-mp="224unta8yr9cl">
            6 Complete Volumes • 150 Ready-to-Teach Lessons • 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-273" data-mp="19g70l94nm9we">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white/5 p-6 rounded-xl border border-white/15" data-id="element-274" data-mp="1egbhh09h56n5">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-275" data-mp="2qir9bbg5bqci">
                <X className="text-danger shrink-0 mt-1" size={18} data-id="element-276" data-mp="2mj0aqlkdo5xf" />
                <p className="text-white/70 text-sm" data-id="element-277" data-mp="1ys39c2q7kr0f">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white p-6 rounded-xl border-2 border-accent" data-id="element-278" data-mp="1tu1obc982hmb">
            <div className="flex items-start gap-3" data-id="element-279" data-mp="3j76mrtjmq0lq">
              <Check className="text-secondary shrink-0 mt-1" size={20} data-id="element-280" data-mp="3ja13pb3fp3ae" />
              <p className="text-primary font-medium text-base leading-relaxed" data-id="element-281" data-mp="3e8vcxitc3q3i">
                Automotive Technology Instructor Ready is a complete PDF-based teaching system with{' '}
                <span className="text-secondary font-bold" data-id="element-282" data-mp="3qtag7d78li3o">100% visual</span> core instructional
                material, created to help Automotive Technology instructors plan less, teach with
                more structure and make complex vehicle systems easier for students to understand.
              </p>
            </div>
          </motion.div>
        </div>

        <ol className="mt-8 flex flex-wrap items-center justify-center gap-2 text-sm font-display font-bold tracking-wider" data-id="element-283" data-mp="eau18elqbngg">
          {flow.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-284" data-mp="3vozihoan5d3o" data-mpi={index}>
              <span className="bg-secondary text-white rounded-md px-3 py-1.5" data-id="element-285" data-mp="4j7t4r4ou4hx">{step}</span>
              {index < flow.length - 1 && <span className="text-accent" aria-hidden="true" data-id="element-286" data-mp="s8adw7umcdgn">
                  →
                </span>}
            </li>)}
        </ol>
      </div>
    </section>;
}